export default __webpack_public_path__ + "static/Nov24-Badge-abcdadea5face54d720246f898818726.svg";